// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-f39bbcae]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.tableBox[data-v-f39bbcae] .el-table__header .el-table__cell {\n  font-weight: bold;\n  color: #333;\n}\n.tableBox[data-v-f39bbcae] .el-table__row {\n  font-size: 12px;\n}", ""]);
// Exports
module.exports = exports;
